export interface NewsletterData {
  title: string;
  description: string;
  placeholder: string;
  buttonText: string;
}

export const NEWSLETTER_DATA: NewsletterData = {
  title: "Newsletter",
  description: "Stay updated with the latest tech insights, industry trends, and Soloop news. Subscribe to our newsletter for exclusive content, project showcases, and expert tips to help your business thrive in the digital landscape.",
  placeholder: "Write your email",
  buttonText: "Send"
}; 